import { formatDate } from "@helpers/date";
import { formatCurrency } from "@src/utility/helpers/utils";
import KycRowActions from "../components/kyc-row-actions";
import KycStatusCell from "../components/kyc-status-cell";
import PublisherCell from "../components/publisher-cell";

// `kyc` is the list's usePublisherKyc() — the row actions open its drawer/reminder.
export const getPublishersColumns = (kyc) => [
    {
        Header  : "Publisher",
        accessor: "holder_name",
        Cell    : ({ row }) => <PublisherCell publisher={row} />
    },
    {
        Header  : "Brand",
        accessor: "brand",
        Cell    : ({ value }) => <span className="text-gray-700">{value}</span>
    },
    {
        Header  : "KYC",
        accessor: "kyc_status",
        Cell    : ({ row }) => <KycStatusCell publisher={row} />
    },
    {
        Header  : "Invoices",
        accessor: "invoices",
        Cell    : ({ value }) => <span className="text-gray-700">{value?.paid ?? 0} of {value?.total ?? 0} paid</span>
    },
    {
        Header  : "Earnings pending",
        accessor: "pending_amount",
        Cell    : ({ value }) => <span className="text-gray-900">{formatCurrency(value)}</span>
    },
    {
        Header  : "Last payout",
        accessor: "last_payout_at",
        Cell    : ({ value }) => <span className="text-gray-700">{formatDate(value)}</span>
    },
    {
        Header  : "",
        accessor: "_id",
        Cell    : ({ row }) => <KycRowActions publisher={row} kyc={kyc} />
    }
];
